<template>
  <MenuRef :iShow="showColor" :openKeys="SubMenu">
    <div class="report">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">客户名称:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.one" />
          </div>
          <div class="search-item">
            <div class="tol-title">业务（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.two" />
          </div>
          <div class="search-item">
            <div class="tol-title">电销（负责人）:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" placeholder="请输入" v-model="form.three" />
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">时间:</div>
            <a-config-provider :locale="locale">
              <a-range-picker :format="dateFormatList" dropdownClassName="time-style" style="flex: 1; width: 434px"
                show-time v-model="timePicker" @change="getStartDatePicker" @clear="onDateClear" /></a-config-provider>
          </div>
          <div class="search-item"></div>
          <div class="search-item" style="display: flex; justify-content: flex-end">
            <a-button @click="reset" class="search-normal"> 重置 </a-button>
            <a-button class="search-btn" :style="{ marginLeft: '24px' }" @click="searchData">
              查询
            </a-button>
          </div>
        </div>
      </div>
      <div class="report-box">
        <div class="report-view">
          <div class="tol-item">
            <div>
              <a-button v-if="permissions.profitReport.canEdit" class="search-normal" @click="openUpdate()">
                修改
              </a-button>
              <a-button v-else type="primary" disabled> 修改 </a-button>
            </div>

            <div>
              <a-button v-if="permissions.profitReport.canExport" :style="{ marginLeft: '16px' }" class="search-normal"
                @click="exportData">
                导出
              </a-button>
              <a-button :style="{
                marginLeft: '16px',
              }" v-else type="primary" disabled>
                导出
              </a-button>
            </div>
          </div>
        </div>
        <div class="report-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <a-table :customRow="customRow" class="report-table" ref="table" size="small" :scroll="{ x: 500 }"
              :rowSelection="rowSelection" :columns="columns" :data-source="tolInformation"
              :rowKey="(record, index) => index" :pagination="pagination"></a-table>
          </a-config-provider>
        </div>
      </div>
      <a-modal v-model="recordUpdate" scrollable title="利润报表修改" :ok-text="'确定'" :cancel-text="'取消'" @ok="recordUpdateOk"
        @cancel="recordUpdateCancel" :wrapClassName="'centered-modal'">
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :model="formData" :rules="ruleValidate" ref="formData" :label-width="120">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="下单时间：">
                  <a-input v-model="formData.createdAt" style="flex: 1; width: 434px; height: 40px" :disabled="true" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="广路单号：">
                  <a-input v-model="formData.waybill" style="flex: 1; width: 434px; height: 40px" :disabled="true" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="客户名称：">
                  <a-input v-model="formData.userName" style="flex: 1; width: 434px; height: 40px" :disabled="true" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="面销人员：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.veneer" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="电销人员：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.telemarketingStaf" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="应收金额：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.total" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="下单金额：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.orderAmount" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="付款状态：">
                  <a-select style="flex: 1; width: 434px; height: 40px" placeholder="请输入" v-model="formData.status">
                    <a-select-option value="1">已下单</a-select-option>
                    <a-select-option value="2">进行中</a-select-option>
                    <a-select-option value="3">已签收</a-select-option>
                    <a-select-option value="4">已取消</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="提货成本：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.deliveryCost" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="专线成本：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.privateLineCost" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="资金占用：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.appropriationFunds" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 43px; display: flex" label="税费：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.commission" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="保险成本：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.insuranceCost" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 29px; display: flex" label="装货费：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.loadingCharges" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 29px; display: flex" label="卸货费：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.landingCharges" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 29px; display: flex" label="木架费：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.timberingCost" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="运作提成：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.operatingCommission" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 14px; display: flex" label="电销提成：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.salesCommission" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="margin-left: 29px; display: flex" label="营销费：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.marketingExpenses" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="margin-left: 43px; display: flex" label="其它：">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.otherExpenses" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="代收手续费：" style="margin-left: 3px; display: flex">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.collectionRatio" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="利润：" style="margin-left: 43px; display: flex">
                  <a-input style="flex: 1; width: 434px; height: 40px" v-model="formData.profit" disabled />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-spin>
      </a-modal>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getOrderList, upsertOrder, exportOrderList } from "@/api";
import MenuRef from "./common/MenuRef";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

//验证判断
const validateValue = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请填入警报数值及单位!"));
  } else if (!/^(\-|\+)?\d+(\.\d+)?$/.test(value)) {
    callback("填入数据非数值类型!");
  } else {
    callback();
  }
};

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      getShow: true,
      showColor: ["3"],
      timePicker: [],
      selectRow: [],
      startDate: null,
      endDate: null,
      dateFormatList: ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss"],
      SubMenu: ["sub-caidan"],
      recordUpdate: false,
      loading: false,
      formData: {
        id: "",
        createdAt: "",
        waybill: "",
        userName: "",
        veneer: "",
        telemarketingStaf: "",
        total: "",
        orderAmount: "",
        status: "1",
        operationPersonnel: "",
        operatingCommission: "",
        salesCommission: "",
        profit: "",
        deliveryCost: "",
        privateLineCost: "",
        appropriationFunds: "",
        commission: "",
        insuranceCost: "",
        loadingCharges: "",
        landingCharges: "",
        timberingCost: "",
        marketingExpenses: "",
        otherExpenses: "",
        collectionRatio: "",
      },
      ruleValidate: {
        value: [
          {
            required: true,
            validator: validateValue,
            trigger: "blur",
          },
        ],
      },
      form: {
        one: "",
        two: "",
        three: "",
      },
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      totalProfit: [{ num: 0 }],
      columns: [
        {
          title: "序号",
          key: "index",
          fixed: "left",
          width: 80,
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "客户项",
          children: [
            {
              title: "下单时间",
              align: "center",
              width: 140,
              customRender: (text, record, index) => {
                return moment(record.createdAt).format("YYYY-MM-DD");
              },
            },
            {
              title: "广路单号",
              align: "center",
              width: 237,
              customRender: (text, record, index) => {
                return record.waybill || "/";
              },
            },
            {
              title: "面销",
              align: "center",
              width: 95,
              customRender: (text, record, index) => {
                return record.veneer || "/";
              },
            },
            {
              title: "电销",
              align: "center",
              width: 95,
              customRender: (text, record, index) => {
                return record.telemarketingStaf || "/";
              },
            },
            {
              title: "客户名称",
              align: "center",
              width: 103,
              customRender: (text, record, index) => {
                return record.user ? record.user.nickname : "/";
              },
            },
            {
              title: "应收金额",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                let h = this.$createElement;
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        cursor: "pointer",
                        color: "#0080FF",
                      },
                      on: {
                        click: () => { },
                      },
                    },
                    "￥" + (record.total || 0)
                  ),
                ]);
              },
            },
          ],
        },
        {
          title: "成本项",
          children: [
            {
              title: "下单金额",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.orderAmount ? "￥" + record.orderAmount : "/";
              },
            },
            {
              title: "付款状态",
              align: "center",
              width: 103,
              customRender: (text, record, index) => {
                return record.status == 1
                  ? "已下单"
                  : record.status == 2
                    ? "进行中"
                    : record.status == 3
                      ? "已签收"
                      : "已取消";
              },
            },
            {
              title: "提货成本",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.deliveryCost ? "￥" + record.deliveryCost : "/";
              },
            },
            {
              title: "专线成本",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.privateLineCost
                  ? "￥" + record.privateLineCost
                  : "/";
              },
            },
            {
              title: "资金占用",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.appropriationFunds
                  ? "￥" + record.appropriationFunds
                  : "/";
              },
            },
            {
              title: "税费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.commission ? "￥" + record.commission : "/";
              },
            },
            {
              title: "保险成本",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.insuranceCost ? "￥" + record.insuranceCost : "/";
              },
            },
            {
              title: "装货费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.loadingCharges
                  ? "￥" + record.loadingCharges
                  : "/";
              },
            },
            {
              title: "卸货费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.landingCharges
                  ? "￥" + record.landingCharges
                  : "/";
              },
            },
            {
              title: "木架费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.timberingCost ? "￥" + record.timberingCost : "/";
              },
            },
            {
              title: "营销费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.marketingExpenses
                  ? "￥" + record.marketingExpenses
                  : "/";
              },
            },
            {
              title: "运作提成",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.operatingCommission
                  ? "￥" + record.operatingCommission
                  : "/";
              },
            },
            {
              title: "电销提成",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.salesCommission
                  ? "￥" + record.salesCommission
                  : "/";
              },
            },
            {
              title: "代收手续费",
              align: "center",
              width: 139,
              customRender: (text, record, index) => {
                return record.collectionRatio
                  ? "￥" + record.collectionRatio
                  : "/";
              },
            },
          ],
        },
        {
          title: "其它",
          align: "center",
          fixed: "right",
          width: 139,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            let point = record.otherExpenses || "";
            return h("a-input", {
              props: {
                value: point,
              },
              on: {
                change: (val) => {
                  const newOtherExpenses = val.target.value;
                  console.log('11111111', record);
                  if (!isNaN(newOtherExpenses)) {
                    this.$set(
                      this.tolInformation[index],
                      "otherExpenses",
                      newOtherExpenses
                    );
                    this.$set(this.totalProfit, index, {
                      num: record.total -
                        (parseFloat(record.deliveryCost || 0) +
                          parseFloat(record.privateLineCost || 0) +
                          parseFloat(record.appropriationFunds || 0) +
                          parseFloat(record.commission || 0) +
                          parseFloat(record.insuranceCost || 0) +
                          parseFloat(record.loadingCharges || 0) +
                          parseFloat(record.landingCharges || 0) +
                          parseFloat(record.timberingCost || 0) +
                          parseFloat(record.operatingCommission || 0) +
                          parseFloat(record.salesCommission || 0) +
                          parseFloat(record.marketingExpenses || 0) +
                          parseFloat(record.collectionRatio || 0) +
                          parseFloat(val.target.value || 0))
                    });
                  }
                },
                blur: async (val) => {
                  const newOtherExpenses = val.target.value;
                  if (!isNaN(newOtherExpenses)) {
                    if (newOtherExpenses.trim() !== "") {
                      const newNum = record.total - (parseFloat(record.deliveryCost || 0) +
                        parseFloat(record.privateLineCost || 0) +
                        parseFloat(record.appropriationFunds || 0) +
                        parseFloat(record.commission || 0) +
                        parseFloat(record.insuranceCost || 0) +
                        parseFloat(record.loadingCharges || 0) +
                        parseFloat(record.landingCharges || 0) +
                        parseFloat(record.timberingCost || 0) +
                        parseFloat(record.operatingCommission || 0) +
                        parseFloat(record.salesCommission || 0) +
                        parseFloat(record.marketingExpenses || 0) +
                        parseFloat(record.collectionRatio || 0) +
                        parseFloat(val.target.value || 0));
                      await this.saveData({
                        id: record.id,
                        otherExpenses: newOtherExpenses,
                        profit: newNum,
                      });
                    }
                  } else {
                    this.$Message.error("所填内容非数字！");
                  }
                },
              },
            });
          },
        },
        {
          title: "利润",
          align: "center",
          fixed: "right",
          width: 120,
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    cursor: "pointer",
                    color: "#14CC76",
                  },
                  on: {
                    click: () => { },
                  },
                },
                "￥" + (this.totalProfit[index].num || 0)
              ),
            ]);
          },
          align: "center",
        },
      ],
      tableHeight: 259,
      // 初始化
      dataCount: 0,
      pageSize: 10,
      pagination: {
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
    };
  },
  methods: {
    moment,
    reset() {
      this.form = {
        one: "",
        two: "",
        three: "",
      };
      this.onDateClear();
      this.basicsData();
    },
    onDateClear() {
      this.startDate = null;
      this.endDate = null;
      this.timePicker = [null, null];
    },
    getStartDatePicker(date, dateString) {
      this.startDate = moment(date[0]);
      this.endDate = moment(date[1]);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    customRow(record, index) {
      return {
        style: {
          // 字体颜色
          //color: "#cceaff",
          // 行背景色
          // "background-color": "#2a3347",
          cursor: "pointer",
        },
        on: {
          // 鼠标单击行
          click: (event) => {
            // this.taskCheckData(record);
          },
        },
      };
    },
    openUpdate() {
      if (Object.keys(this.selectRow).length !== 0) {
        let list = this.selectRow[0];
        this.formData.createdAt = moment(list.createdAt).format("YYYY-MM-DD");
        this.formData.waybill = list.waybill;
        this.formData.userName = list.user.nickname;
        this.formData.veneer = list.veneer;
        this.formData.telemarketingStaf = list.telemarketingStaf;
        this.formData.total = list.total;
        this.formData.orderAmount = list.orderAmount;
        this.formData.operationPersonnel = list.operationPersonnel;
        this.formData.operatingCommission = list.operatingCommission;
        this.formData.salesCommission = list.salesCommission;
        this.formData.profit = list.profit;
        this.formData.deliveryCost = list.deliveryCost;
        this.formData.privateLineCost = list.privateLineCost;
        this.formData.appropriationFunds = list.appropriationFunds;
        this.formData.commission = list.commission;
        this.formData.method = list.method + "";
        this.formData.insuranceCost = list.insuranceCost;
        this.formData.loadingCharges = list.loadingCharges;
        this.formData.landingCharges = list.landingCharges;
        this.formData.timberingCost = list.timberingCost;
        this.formData.marketingExpenses = list.marketingExpenses;
        this.formData.otherExpenses = list.otherExpenses;
        this.formData.collectionRatio = list.collectionRatio;
        this.formData.id = list.id;
        this.recordUpdate = true;
      } else {
        this.$Message.warning("请选择所要修改的一行！");
      }
    },
    recordUpdateOk() {
      this.formData.method = parseInt(this.formData.method);
      this.saveData(this.formData);
    },
    recordUpdateCancel() {
      this.$emit("close");
    },
    async saveData(params) {
      this.loading = true;
      await upsertOrder(params).then((res) => {
        if (res.statusCode == 200) {
          this.$Message.success("数据保存成功！");
          this.basicsData();
        } else {
          this.loading = false;
          this.$Message.error("数据保存失败！");
        }
      });
    },
    basicsData() {
      getOrderList({
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        name: this.form.one,
        veneer: this.form.two,
        telemarketingStaf: this.form.three,
        startTime: this.startDate ? moment(this.startDate).toISOString() : null,
        endTime: this.endDate ? moment(this.endDate).toISOString() : null,
        timeSearch: this.startDate && this.endDate ? "createdAt" : null,
      }).then((res) => {
        if (res.data) {
          this.loading = false;
          this.recordUpdate = false;
          this.tolInformation = res.data.list;
          this.dataCount = res.data.total;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = this.dataCount;
          this.totalProfit = this.tolInformation.map((item) => ({
            num: item.profit || 0,
          }));
        }
      });
    },
    async onPageChange(page) {
      this.pageNum = page;
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
    calculateProfit() {
      const {
        total,
        deliveryCost,
        privateLineCost,
        appropriationFunds,
        commission,
        insuranceCost,
        loadingCharges,
        landingCharges,
        timberingCost,
        operatingCommission,
        salesCommission,
        marketingExpenses,
        otherExpenses,
        collectionRatio
      } = this.formData;

      this.formData.profit =
        parseFloat(total || 0) -
        (parseFloat(deliveryCost || 0) +
          parseFloat(privateLineCost || 0) +
          parseFloat(appropriationFunds || 0) +
          parseFloat(commission || 0) +
          parseFloat(insuranceCost || 0) +
          parseFloat(loadingCharges || 0) +
          parseFloat(landingCharges || 0) +
          parseFloat(timberingCost || 0) +
          parseFloat(operatingCommission || 0) +
          parseFloat(salesCommission || 0) +
          parseFloat(marketingExpenses || 0) +
          parseFloat(collectionRatio || 0) +
          parseFloat(otherExpenses || 0));

      if (isNaN(this.formData.profit)) {
        this.$Message.error("有输入框输入非数字，请修改！！！");
      }
    },
    exportData() {
      let params = {};

      params = {
        header: [
          "广路单号",
          "下单时间",
          "客户名称",
          "面销人员",
          "电销人员",
          "应收金额",
          "下单金额",
          "付款状态",
          "提货成本",
          "专线成本",
          "资金占用",
          "税费",
          "保险成本",
          "装货费",
          "卸货费",
          "木架费",
          "营销费",
          "其它",
          "运作提成",
          "电销提成",
          "利润",
        ],
        headervalues: [
          "waybill",
          "createdAt",
          "user[]nickname",
          "veneer",
          "telemarketingStaf",
          "total",
          "orderAmount",
          "status",
          "deliveryCost",
          "privateLineCost",
          "appropriationFunds",
          "commission",
          "insuranceCost",
          "loadingCharges",
          "landingCharges",
          "timberingCost",
          "marketingExpenses",
          "otherExpenses",
          "operatingCommission",
          "salesCommission",
          "profit",
        ],
        name: this.form.one,
        veneer: this.form.two,
        telemarketingStaf: this.form.three,
        startTime: this.startDate ? moment(this.startDate).toISOString() : null,
        endTime: this.endDate ? moment(this.endDate).toISOString() : null,
        timeSearch: this.startDate && this.endDate ? "createdAt" : null,
      };

      exportOrderList({ ...params }).then((data) => {
        if (!data || data.size <= 0) {
          this.$Message.error("没有数据导出失败");
          return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().format("YYYY-MM-DD")}-订单数据.xlsx`
        );

        document.body.appendChild(link);
        link.click();
      });
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.basicsData();
  },
  computed: {
    rowSelection() {
      return {
        type: "radio",
        onChange: (selectedRowKeys, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelect: (record, selected, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
      };
    },
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
    formData: {
      handler: "calculateProfit",
      deep: true,
    },
  },
};
</script>

<style lang="less">
.report {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-cond {
    width: 100%;
    height: 144px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  .report-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;

    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }

    .report-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;

      .tol-item {
        display: flex;
        align-items: center;

        .tol-add {
          margin-left: 20px;
        }

        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }

        .Select-style {
          width: 336px;
          height: 40px;
        }
      }
    }

    .report-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;

      // 表格
      .report-table {
        height: 100%;

        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }

        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.ant-modal {
  display: flex;
  justify-content: center;
  width: 1200px !important;
}

/deep/.ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/.ant-select-selection--multiple .ant-select-selection__rendered {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/.ant-modal-content {
  width: 1200px !important;
}

/deep/.ant-calendar-picker-input.ant-input {
  height: 40px !important;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-thead>tr>th {
  background: #f5f5f5 !important;
  border: 1px solid #f0f0f0 !important;
}

/deep/.ant-table-tbody>tr>td {
  border-bottom: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

/deep/.ant-table-small>.ant-table-content>.ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}
</style>
